
import {sessionStorageLoad, sessionStorageSave, sessionStorageRemove} from '../js/utilities';

export const STORAGE_HANDLER_KEY = {
  SESSION: 'SESSION'
};

export const storageHandlers = {
  [STORAGE_HANDLER_KEY.SESSION]: {
    retrieveCache: (request) => {
      let storageKey = 'REQUEST:' + request.requestId;
      return sessionStorageLoad(storageKey);
    },
    saveCache: (request) => {
      let storageKey = 'REQUEST:' + request.requestId;
      sessionStorageSave(storageKey, request);
    },
    clearCache: (request) => {
      let storageKey = 'REQUEST:' + request.requestId;
      sessionStorageRemove(storageKey);
    }
  }
};



// WEBPACK FOOTER //
// ./assets/utilities/requestStorageHandlers.js